import React, { useCallback } from 'react';
import { Typography, Box } from '@mui/material';
import { Button } from '@ui/buttons';
import { useNavigate } from 'react-router-dom';

export const ErrorPage: React.FC<{ message?: string }> = ({ message }) => {
  const navigate = useNavigate();

  const reloadApplication = useCallback(() => {
    navigate('/');
    window.location.reload();
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 2,
      }}
    >
      <Typography variant="h4">Unknown Error</Typography>
      {message && <Typography>{message}</Typography>}
      <Typography>
        We&apos;re sorry, but something went wrong. Please contact Nodon.
      </Typography>
      <Button variant="outlined" onClick={reloadApplication}>
        Reload application
      </Button>
    </Box>
  );
};
